<div class="reset-page">
  <mat-card class="reset-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title>Reset Password</mat-card-title>
      <mat-card-subtitle>Enter your new password for SNF Dashboard account</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" class="reset-form">
        <div class="field">
          <mat-form-field appearance="outline">
            <mat-label>New Password</mat-label>
            <input matInput type="password" formControlName="password" autocomplete="new-password" />
          </mat-form-field>

          @if(resetForm.get('password')?.invalid && (resetForm.get('password')?.dirty || resetForm.get('password')?.touched)) {
          @if(resetForm.get('password')?.errors?.['required']) {
          <div class="error">New password is required.</div>
          }
          @if(resetForm.get('password')?.errors?.['pattern']) {
          <div class="error">New password must be at least 8 characters and include uppercase and lowercase letters, a number, and a symbol.</div>
          }
          }
        </div>

        <div class="field">
          <mat-form-field appearance="outline">
            <mat-label>Confirm Password</mat-label>
            <input matInput type="password" formControlName="confirmPassword" autocomplete="new-password" />
          </mat-form-field>

          @if(resetForm.get('confirmPassword')?.invalid && (resetForm.get('confirmPassword')?.dirty || resetForm.get('confirmPassword')?.touched)) {
          @if(resetForm.get('confirmPassword')?.errors?.['required']) {
          <div class="error">Confirm password is required.</div>
          }
          }
          @if(resetForm.errors?.['passwordMismatch'] && (resetForm.get('confirmPassword')?.dirty || resetForm.get('confirmPassword')?.touched)) {
          <div class="error">Passwords do not match.</div>
          }
        </div>

        <button mat-flat-button type="submit" color="primary" class="submit-btn" [disabled]="isSubmitting()">
          @if (isSubmitting()) { Updating Password... } @else { Update Password }
        </button>
      </form>

      @if (errorMessage()) {
      <div class="error-message">{{ errorMessage() }}</div>
      }
      @if (successMessage()) {
      <div class="success-message">{{ successMessage() }}</div>
      }

      <a class="back-link" routerLink="/login">Back to Login</a>
    </mat-card-content>
  </mat-card>
</div>
